import { observer } from "mobx-react";
import { h } from "preact";
import { t, Tracking, translate, } from "restaumatic-client";
import CrossSellingList from "./CrossSellingList";
import PreactModal, { ModalHeader } from "./PreactModal";
import { hideModal } from "../utils/Modals";
function CrossSellingBottomSheet(props) {
    const { id, title, message, place, crossSellingBottomSheet } = props;
    const { crossSellingItems } = crossSellingBottomSheet;
    const handleClick = () => {
        var _a, _b;
        Tracking.trackEvent({
            tag: "CrossSellingBottomSheetCtaClicked",
            contents: {
                price: (_b = (_a = crossSellingBottomSheet.trackingPrice) === null || _a === void 0 ? void 0 : _a.asNumber) !== null && _b !== void 0 ? _b : -1,
            },
        });
        crossSellingBottomSheet.addToCart(place);
        void hideModal(id);
    };
    return (h(PreactModal, { id: id, modalClass: "modal-dialog--bottomsheet", onShow: () => crossSellingBottomSheet.cleanSelectedItems() },
        h(ModalHeader, { title: title }),
        h("div", { class: "modal-body" },
            h("p", { class: "u-mb3" }, message),
            crossSellingItems.length > 0 && (h(CrossSellingList, { title: translate(t.crossup.title), fieldId: "bottomsheet.crossSelling", items: crossSellingItems }))),
        h("div", { class: "modal-footer modal-footer--sticky" },
            h("button", { type: "button", class: "btn btn-primary btn-block", onClick: handleClick }, crossSellingBottomSheet.buttonText))));
}
export default observer(CrossSellingBottomSheet);
